import { DateInputKey } from './';
import { createTextInputDriver, createDeprecatedLinkButtonDriver, popoverDriver } from '../../drivers';
import { createDatePickerDriver } from '../date-picker/driver';
export var createDateInputDriver = function (wrapper, global) {
    var base = wrapper.$("." + DateInputKey);
    var inputDriver = createTextInputDriver(wrapper);
    var popover = popoverDriver(global);
    return {
        date: function () { return inputDriver.value(); },
        openCalendar: function () { return createDeprecatedLinkButtonDriver(wrapper).click(); },
        datePicker: createDatePickerDriver(popover),
        base: base
    };
};
//# sourceMappingURL=driver.js.map